<template>
  <div class="editor-wrapper">
    <div :id="editorId"></div>
  </div>
</template>

<script>
let nid = -1
import Editor from 'wangeditor'
import 'wangeditor/release/wangEditor.min.css'
import { oneOf } from '@/libs/tools'
import {baseUrl} from '../../../vue.config'
export default {
  name: 'Editor',
  props: {
    value: {
      type: String,
      default: ''
    },
    /**
     * 绑定的值的类型, enum: ['html', 'text']
     */
    valueType: {
      type: String,
      default: 'html',
      validator: (val) => {
        return oneOf(val, ['html', 'text'])
      }
    },
    /**
     * @description 设置change事件触发时间间隔
     */
    changeInterval: {
      type: Number,
      default: 200
    },

    /**
     * @description 是否开启本地存储
     */
    cache: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    editorId () {
      return `editor${this._uid}`
    }
  },

  methods: {
    setHtml (val,nid) {

      this.editor.customConfig.uploadImgParams = {
        nid: nid
      }
      this.editor.create()
      this.editor.txt.html(val)
    },

  },
  mounted () {
    this.editor = new Editor(`#${this.editorId}`)
    this.editor.customConfig.onchange = (html) => {
      console.log(this.customdata)
      let text = this.editor.txt.text()
      if (this.cache) localStorage.editorCache = html
      this.$emit('input', this.valueType === 'html' ? html : text)
      this.$emit('on-change', html, text)

    }
    this.editor.customConfig.onchangeTimeout = this.changeInterval
    // 将图片大小限制为 3M
    this.editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024
// 限制一次最多上传 5 张图片
    this.editor.customConfig.uploadImgMaxLength = 5
//上传图片的错误提示默认使用alert弹出,也可以自定义用户体验更好的提示方式
    this.editor.customConfig.customAlert = function (info) {
      // info 是需要提示的内容
      alert('自定义提示：' + info)
    }
    // 上传图片到服务器,对应的是controller层的@RequestMapping("/upload")
    // this.editor.customConfig.uploadImgServer = "/v1/newsinfo/upload/" //测试
    this.editor.customConfig.uploadImgServer = "/api/v1/newsinfo/upload/" //正式
    //自定义name,接收的时候图片文件的那么用这个，对应的是参数中的MultipartFile upimg名称,这个名称即上传到浏览器的参数名称
    this.editor.customConfig.uploadFileName = "imgdata"

    // 上传图片的结果反馈

    this.editor.customConfig.uploadImgHooks = {
      before: function(xhr, editor, files) {
// 图片上传之前触发
// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
// 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
// return {
// prevent: true,
// msg: '放弃上传'
// }

        console.log("before:",xhr)
        console.log(editor)
        console.log(files)


      },
      success: function(xhr, editor, result) {
// 图片上传并返回结果，图片插入成功之后触发
// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
console.log("success:",result)
      },
      fail: function(xhr, editor, result) {
// 图片上传并返回结果，但图片插入错误时触发
// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
        console.log("fail:",result)
      },
      error: function(xhr, editor) {
// 图片上传出错时触发
// xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        console.log("error:",result)
      },
// 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
// （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
      customInsert: function(insertImg, result, editor) {
// 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
// insertImg 是插入图片的函数，参数editor 是编辑器对象，result 是服务器端返回的结果
// 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
//         console.log("back:",result)
        if (result.code == 0){
          var url = result.filename;
          console.log(baseUrl + '/upload-image/news/' + url)
          insertImg(baseUrl + 'upload-image/news/' + url);
        }

// result 必须是一个 JSON 格式字符串！！！否则报错
      }
    };
// }


    // create这个方法一定要在所有配置项之后调用
    // this.editor.create()
    // 如果本地有存储加载本地存储内容
    // let html = this.value || localStorage.editorCache
    // if (html) this.editor.txt.html(html)
  }
}
</script>

<style>

</style>
